import React from 'react';

// Boundary minimal, périmètre volontairement restreint au module territory_intro
// (webGL/three.js = plus grosse surface de risque de plantage de rendu de l'app —
// aucun ErrorBoundary n'existe ailleurs dans le reste de l'app aujourd'hui). Le
// fallback est fourni par l'appelant pour pouvoir, par exemple, laisser le joueur
// continuer la partie plutôt que de rester bloqué sur un écran blanc.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary a intercepté une erreur :', error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
